import ArticleDetail from "./articleDetail";
export default ArticleDetail;